

export const getSearchCardUri = (item: any) => {
    if (item?.entryType === 'eauSections_eauSectionMember_Entry' ||
        item?.entryType === 'offices_officeMember_Entry'
    ) {
        return item.parent?.uri;

    }
    return item?.uri;
};

// Returns only the search results that have a valid uri
export const useFilteredSearchResults = (data: ComputedRef<{entries: any[], entryCount: number}>) => {
    const entries = computed(() => data.value.entries.filter((item) => {
        const uri = getSearchCardUri(item);
        return uri !== undefined;
    }));

    return {
        entries,
        totalEntries: computed(() => data.value.entryCount)
    };
};
